import React from "react";
import "../ECommerce/ECommerce.css";
import "../Page.css";
import axios from "axios";
import { security_key, Url } from "../../Services/Api";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { useState, useEffect, useRef } from "react";
import { formatOrderDate } from "../../Components/UI-Controls/DateFormat/DateFormat";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import ElipticalPagenation from "../../Components/UI-Controls/Pagination/Pagination2";
import { FiEdit } from "react-icons/fi";
import { IoEyeOutline } from "react-icons/io5";
import InputField from "../../Components/UI-Controls/InputField/InputField";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { CiWarning } from "react-icons/ci";
import { Tooltip } from 'antd';

const AllLandingPages = () => {
    const rowsPerPage = 10;
    const navigate = useNavigate();
    const modalRef = useRef(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [custName, setCustName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [filtersModified, setFiltersModified] = useState(false);
    const [filteredData, setFilteredData] = useState(data);
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [currentRowId, setCurrentRowId] = useState(null);
    const [isActive, setIsActive] = useState(false);
    const [error, setError] = useState(null);
    const [totalPages, setTotalPages] = useState(null);

    useEffect(() => {
        fetchData();
    }, [currentPage]);

    const timeZone = "America/New_York";

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        setTimeout(async () => {
            try {
                const response = await axios.get(`${Url}/api/v1/landing-pages/get-all-landing-pages?page=${currentPage}`);
                const allData = response.data.data || [];
                const reversedData = allData.reverse();
                setData(reversedData);
                setFilteredData(reversedData);
                setToastMessage(" Data have been fetched successfully!");
                setShowMessage(true);
                setTotalPages(response.data?.totalPages)
            } catch (error) {
                const errMsg = error?.response?.data?.message || error.message;
                setError(errMsg);
                setToastMessage(`Failed to fetch  Data: ${errMsg}`);
                setShowMessage(true);
            } finally {
                setLoading(false);
            }
        }, 2000);
    };

    const handleCloseMessageModal = () => {
        setShowMessage(false);
    };

    useEffect(() => {
        if (showMessage === true) {
            const timeOut = setTimeout(() => {
                setShowMessage(false);
            }, 3000);

            return () => clearTimeout(timeOut);
        }
    }, [showMessage]);

    const customStyles = {
        headCells: {
            style: {
                height: "clamp(50px, 5vw, 56px)",
                background: "transparent",
                opacity: "1",
                textAlign: "center",
                justifyContent: "center",
                border: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-medium)",
                fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
            },
        },
        cells: {
            style: {
                height: "clamp(50px, 6vw, 66px)",
                justifyContent: "center",
                textAlign: "center",
                background: "transparent",
                borderTop: "var(--standered-border)",
                borderRight: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-regular)",
                fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
            },
        },
    };

    const toggleDropdown = (id) => {
        setOpenDropdownId((prevId) => (prevId === id ? null : id));
    };

    const handleAction = (action, row) => {
        console.log(`Action: ${action} triggered for row:`, row);
        switch (action) {
            case "view":
                handleView(row);
                setOpenDropdownId(null);
                break;
            case "edit":
                handleEdit(row);
                setOpenDropdownId(null);
                break;
            default:
                break;
        }
    };







    const handleEdit = (row) => {
        navigate(`/Pages/Landing-Pages/Edit/${row._id}`, { state: { page_Data: row } });
    };

    const handleView = (row) => {
        navigate(`/Pages/Landing-Pages/View/${row._id}`, { state: { view_Data: row } });
    };

    const handleClickOutside = (event) => {
        if (
            !event.target.closest(".dropdown-menu") &&
            !event.target.closest(".bar-icon")
        ) {
            setOpenDropdownId(null);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const DataColumns = [
        {
            name: (
                <input
                    type="checkbox"
                    style={{ margin: 0 }}
                    onChange={(e) => console.log("All selected:", e.target.checked)}
                />
            ),
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="20px" height="22px" />
                ) : (
                    <input
                        type="checkbox"
                        style={{ margin: 0 }}
                        onChange={(e) => console.log("Selected:", row, e.target.checked)}
                    />
                ),
            ignoreRowClick: true,
            width: "50px",
        },
        {
            name: "Date",
            selector: (row) => {
                if (loading) {
                    return (
                        <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />
                    );
                }

                const { formattedDate, hoursAgo, showYesterday } = formatOrderDate(
                    row.createdAt
                );

                return hoursAgo
                    ? hoursAgo
                    : showYesterday
                        ? "Yesterday"
                        : formattedDate;
            },
            minWidth: "115px",
            maxWidth: "175px",
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div
                        style={{
                            whiteSpace: "normal",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            maxHeight: "44px",
                        }}
                    >
                        {(() => {
                            const { formattedDate, hoursAgo, showYesterday } =
                                formatOrderDate(row.createdAt);
                            return hoursAgo
                                ? hoursAgo
                                : showYesterday
                                    ? "Yesterday"
                                    : formattedDate;
                        })()}
                    </div>
                ),
        },
        {
            name: "Title",
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="200px" height="22.5px" borderRadius="20px" />
                ) : (
                    <Tooltip title={row.title}>
                        <div
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "100%",
                            }}
                        >
                            {row.title}
                        </div>
                    </Tooltip>
                ),
            minWidth: "280px",
            maxWidth: "400px",
        },
        {
            name: "Author",
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="200px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div>{row.author}</div>
                ),
            minWidth: "120px",
            maxWidth: "200px",
        },
        {
            name: "Status",
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="200px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div>{row?.status || "No Statuss"}</div>
                ),
            minWidth: "175px",
            maxWidth: "200px",
        },
        {
            name: "Action",
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="60px" height="22.5px" />
                ) : (
                    <div style={{ position: "relative" }}>
                        <img
                            src={actionIcon}
                            alt="Action Icon"
                            width="40"
                            height="40"
                            style={{ cursor: "pointer", margin: 0, padding: 0 }}
                            className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""
                                }`}
                            onClick={() => toggleDropdown(row._id)}
                        />
                        {openDropdownId === row._id && (
                            <div className={`dropdown-menu show animate-dropdown-left`}>
                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                    <li
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            padding: "5px 10px",
                                            border: "none",
                                        }}
                                        onClick={() => handleAction("view", row)}
                                    >
                                        <IoEyeOutline style={{ marginRight: "12px" }} className="icon-img-updated" />
                                        View
                                    </li>
                                    <li
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            padding: "5px 10px",
                                            border: "none",
                                        }}
                                        onClick={() => handleAction("edit", row)}
                                    >
                                        <FiEdit style={{ marginRight: "12px" }} className="icon-img-updated" />
                                        Edit
                                    </li>

                                </ul>
                            </div>
                        )}
                    </div>
                ),
            minWidth: "100px",
            maxWidth: "125px",
        },
    ];


    const paginatedData = filteredData;

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const placeholderRows = Array(7).fill({ uid: "", name: "", image: "" });

    const displayedData = loading ? placeholderRows : paginatedData;

    const handleAddPage = () => {
        navigate("/Pages/Landing-Pages/Add-Landing-Page");
    };

    return (
        <div className="AllOrderPage">
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",paddingRight:"10px",marginBottom:"10px"}}>
                <div></div>
 <CustomBtn
                label="Add New"
                withIcon={true}
                iconType="plus"
                className="AddBtn"
                onClick={handleAddPage}
                type="submit"
            />
            </div>
           
            <div className="Orders-Table-Data">
                <div>
                    <DataTable
                        columns={DataColumns}
                        data={displayedData}
                        customStyles={customStyles}
                    />
                    <ElipticalPagenation
                        activePageIndex={currentPage}
                        totalPages={totalPages}
                        onPrevPage={handlePrevPage}
                        onNextPage={handleNextPage}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div>



            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => handleCloseMessageModal()}
            />

        </div>
    );
};

export default AllLandingPages;